<div class="tray-body">
    <!-- For screen reader only. Informs the user that the products list has been updated -->
    @if (hasSeenProductUpdate === true) {
    <p hSrOnlyNoSnippet [attr.aria-live]="'polite'" [attr.aria-atomic]="'true'">
        <span i18n="@@hermes.accessibility.update">Update</span>
        @if (collectionSize){
        <span>&nbsp;{{ collectionSize }} </span>
        @if (collectionSize < 2) {
        <span i18n="@@hermes.accessibility.product">item</span>
        } @else {
        <span i18n="@@hermes.accessibility.products">items</span>
        } }
    </p>
    }
    <ng-container [formGroup]="filterGroupForm">
        @for (gridFilterGroup of gridFilterGroups; track trackByFilterGroup(idx, gridFilterGroup); let idx = $index) {
        @if (gridFilterGroup.presentation === 'switch') {
        <h-switch-button
            [isSwitchEnabled]="gridFilterGroup | switchFilterChecked"
            (checked)="switchFilterClicked(gridFilterGroup, $event)">
            {{ gridFilterGroup.name }}
        </h-switch-button>
        } @else if (gridFilterGroup.presentation !== 'switch') {
        <h-expansion-panel
            [class.filter-colors]="isTypeFilter(gridFilterGroup.presentation, [typeFilter.COLORS, typeFilter.GRID])"
            [collapsed]="toggleFilterGroupCollapsed[gridFilterGroup.name]"
            [expansionPanelId]="gridFilterGroup.name"
            [backgroundColor]="transparentColor"
            [noPaddingHeader]="true"
            [contentPadding]="'0'"
            [noBorder]="true"
            [headerLeftPadding]="2"
            [adjustScroll]="true"
            [applyFocusOffset]="false"
            [scrollBehavior]="'smooth'"
            [scrollPosition]="'start'"
            [animationDuration]="750"
            (collapsedChange)="handleCollapsedChange($event.id)"
            [dataTestId]="gridFilterGroup.name">
            <ng-container *hExpansionPanelPart="'header'">
                <div class="header-title-current">
                    <span class="label-medium-bold-uppercase">{{ gridFilterGroup.name | uppercase }}&nbsp;</span>
                    @if (gridFilterGroup.counterChecked) {
                    <sup class="header-title-current-number-result">({{ gridFilterGroup.counterChecked }}) </sup>
                    <p hSrOnlyNoSnippet>
                        @if (gridFilterGroup.counterChecked && gridFilterGroup.counterChecked < 2) {
                        <span i18n="@@hermes.accessibility.product">item</span>
                        } @else {
                        <span i18n="@@hermes.accessibility.products">items</span>
                        }
                    </p>
                    }
                </div>
            </ng-container>

            <ng-container *hExpansionPanelPart="'content'">
                @if (isTypeFilter(gridFilterGroup.presentation, [typeFilter.SLIDER])) {
                <h-price-slider
                    [priceRange]="priceRange"
                    [isExpanded]="true"
                    (valueChange)="handlePriceChange(gridFilterGroup, $event)">
                </h-price-slider>
                } @else if (isTypeFilter(gridFilterGroup.presentation, [typeFilter.LIST])) {
                <h-grid-filter-list
                    [attr.role]="'group'"
                    [attr.aria-describedby]="gridFilterGroup.name"
                    [gridFilterGroup]="gridFilterGroup"
                    [filterGroupForm]="filterGroupForm.controls.listForm">
                </h-grid-filter-list>
                } @else if (isTypeFilter(gridFilterGroup.presentation, [typeFilter.COLORS, typeFilter.GRID])) {
                <h-grid-filter-color-and-size
                    [class.colors-gap]="isTypeFilter(gridFilterGroup.presentation, [typeFilter.COLORS])"
                    [gridFilterGroup]="gridFilterGroup"
                    [filterGroupForm]="filterGroupForm.controls.colorAndSizeForm">
                </h-grid-filter-color-and-size>
                }
            </ng-container>
        </h-expansion-panel>
        } }
    </ng-container>
    <ng-container>
        <h-expansion-panel
            [contentPadding]="'0'"
            [collapsed]="toggleFilterGroupCollapsed[sortByName]"
            [expansionPanelId]="sortByName"
            [backgroundColor]="transparentColor"
            [noBorder]="true"
            [noPaddingHeader]="true"
            [adjustScroll]="true"
            [applyFocusOffset]="false"
            [headerLeftPadding]="2"
            [scrollBehavior]="'smooth'"
            [scrollPosition]="'start'"
            [animationDuration]="500"
            (collapsedChange)="handleCollapsedChange($event.id)"
            [dataTestId]="sortByName">
            <ng-container *hExpansionPanelPart="'header'">
                <div class="header-title-current">
                    <span class="label-medium-bold-uppercase" i18n="@@hermes-search-result.sort-by"> Sort by</span>
                </div>
            </ng-container>
            <ng-container *hExpansionPanelPart="'content'">
                <div class="sort-by-container">
                    <ng-container [formGroup]="filterSortByForm">
                        @for (sortOption of sortOptions; track trackBySortOption(idx, sortOption); let idx = $index) {
                        <h-radio-button
                            [id]="sortByName + '-' + sortOption.sort"
                            [name]="'sort_by_' + sortOption.sort"
                            [controlName]="sortByName"
                            [value]="sortOption"
                            [label]="sortOption.label"
                            [labelStyle]="'light'"
                            [hasSeparator]="false"
                            [isCollapsible]="false"
                            [buttonStyle]="'thin'"
                            [isAnimationDisabled]="true"
                            (radioCheckedEvent)="onRadioChecked($event.selected)">
                        </h-radio-button>
                        }
                    </ng-container>
                </div>
            </ng-container>
        </h-expansion-panel>
    </ng-container>
</div>

<div class="tray-footer" [class.has-filter]="hasSelectedFilters$ | async">
    @if ((hasSelectedFilters$ | async) || !isDefaultSortBy) {
    <h-call-to-action
        (click)="onClearFilters()"
        (keyup.enter)="onClearFilters()"
        [appearance]="'secondary'"
        [size]="isMobile ? smallButton : largeButton"
        [dataTestId]="'Clear'"
        i18n-aria-label="@@hermes.accessibility.clear.filters.applied"
        aria-label="Clear filters applied"
        i18n="@@hermes_checkout.modules.filters.clear.label">
        Clear
    </h-call-to-action>
    }
    <h-call-to-action
        (click)="closeTray()"
        [size]="isMobile ? smallButton : largeButton"
        [dataTestId]="'Apply'"
        i18n="@@hermes-search-result.button-label">
        Apply
    </h-call-to-action>
</div>
